import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Outline from "../Outline/Outline";
import CourseActivityIcon from "../Icons/CourseActivityIcon";

const PolicyOutline = ({ policyContent }) => {
  const { t } = useTranslation();
  const [policyContentOutline, setPolicyContentOutline] = useState([]);

  useEffect(() => {
    const outline = policyContent
      ? policyContent.map(section => ({
          title: section.title,
          items: section.items.map(item => ({
            title: item.title,
            icon: <CourseActivityIcon type={item.type} />
          }))
        }))
      : [];
    setPolicyContentOutline(outline);
  }, [policyContent]);

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" my={3}>
        <Typography variant="h5">
          {t("courseVersion.details.policyOutline")}
        </Typography>
      </Box>
      <Box mt={4}>
        <Outline sections={policyContentOutline} />
      </Box>
    </Box>
  );
};

export default PolicyOutline;

PolicyOutline.propTypes = {
  policyContent: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          type: PropTypes.string,
          title: PropTypes.string
        })
      )
    })
  )
};
